import { render, staticRenderFns } from "./JobView.vue?vue&type=template&id=7c013442&scoped=true"
import script from "./JobView.vue?vue&type=script&setup=true&lang=js"
export * from "./JobView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./JobView.vue?vue&type=style&index=0&id=7c013442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c013442",
  null
  
)

export default component.exports